import gql from 'graphql-tag'

export default gql`
  query PodsQuery($role: Role!) {
    administrators(role: $role) {
      rid
      name
      link
      isLendingManager
      isAccountManager
      isRelationshipManager
    }
    pods {
      rid
      name
      admins {
        rid
        name
        email
        link
        isLendingManager
        isAccountManager
        isRelationshipManager
      }
    }
  }
`
